<template>
  <div class="full-screen" style="z-index: 6">
    <router-view></router-view>
  </div>
</template>

<script>
  import Top from '@/components/layer2/book/book-top'
  import scrollService from "../../../services/scrollService";

  export default {
    name: "book-index",
    data() {
      return {
        topTitle: '',
        topTitle2: ''
      }
    },
    methods: {},
    components: {
      top: Top
    },
    mounted() {
      scrollService.scrollToTop();
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/layer2/book/index.vue